import { message } from 'antd';
import { config } from "util/config";
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { getUieDataSource } from 'components/UIBuilder/SectionFunction/Common';

let setAutoComplete = false;
//Search Address从google map找自动完成地址的数据源
export function searchAddressChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && setAutoComplete === false) {
    setAutoComplete = true;

    let options = {
      componentRestrictions: {
        country: ['au']
      }
    };

    var input = document.getElementById('ClientSearchAddress');
    var autocomplete = new window.google.maps.places.Autocomplete(input, options);

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (place.place_id.length > 150) {
        message.warning('The address you selected does not exist. Please select another one.');
      } else {
        for (var i = 0; i < place.address_components.length; i++) {
          if (place.address_components[i].types[0] == "street_number") {
            formComponent.formRef.current?.setFieldValue('StreetNumber', place.address_components[i].long_name);
          }
          if (place.address_components[i].types[0] == "route") {
            formComponent.formRef.current?.setFieldValue('StreetName', place.address_components[i].long_name);
          }
          if (place.address_components[i].types[0] == "locality") {
            formComponent.formRef.current?.setFieldValue('Suburb', place.address_components[i].long_name);
          }
          if (place.address_components[i].types[0] == "administrative_area_level_1") {
            formComponent.formRef.current?.setFieldValue('State', place.address_components[i].short_name);
          }
          if (place.address_components[i].types[0] == "postal_code") {
            formComponent.formRef.current?.setFieldValue('Postcode', place.address_components[i].long_name);
          }
        }
        formComponent.formRef.current?.setFieldValue('ClientSearchAddress', place.formatted_address);
      }
    })
  }
}

export function addClientPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setAutoComplete = false;
}

export function editClientPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setAutoComplete = false;
}

//选Same As Client Address时给Postal Address赋值
export function setSameAsClientAddress({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter) {
    formComponent.formRef.current?.setFieldValue('PostalStreetNumber', formComponent.formRef.current?.getFieldValue('StreetNumber'));
    formComponent.formRef.current?.setFieldValue('PostalStreetName', formComponent.formRef.current?.getFieldValue('StreetName'));
    formComponent.formRef.current?.setFieldValue('PostalSuburb', formComponent.formRef.current?.getFieldValue('Suburb'));
    formComponent.formRef.current?.setFieldValue('PostalState', formComponent.formRef.current?.getFieldValue('State'));
    formComponent.formRef.current?.setFieldValue('PostalPostcode', formComponent.formRef.current?.getFieldValue('Postcode'));
  } else {
    formComponent.formRef.current?.setFieldValue('PostalStreetNumber', '');
    formComponent.formRef.current?.setFieldValue('PostalStreetName', '');
    formComponent.formRef.current?.setFieldValue('PostalSuburb', '');
    formComponent.formRef.current?.setFieldValue('PostalState', '');
    formComponent.formRef.current?.setFieldValue('PostalPostcode', '');
  }
}

//跳转管理ClientUser的页面
export function manageClientUser({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  pageComponent.props.history.push('/admin/client-user?clientId=' + parameter.ClientId);
}
